// extracted by mini-css-extract-plugin
export default {"container":"V0-z","list":"W0-z"};